module.exports = __webpack_public_path__ + "img/40_69_015_590.1fc7a845.jpg";